// extracted by mini-css-extract-plugin
export default {"card":"styles_card__C0vcP","column":"styles_column__EtcWl"};